// Generated ESM version of image.js for Vite compatibility from packages/shared/const/image.js

export const DEFAULTS_AVATAR = "https://oss-resource668.yzdli.com/website/image/default/default-avatar.png";
export const DEFAULTS_AVATAR_BIG = "https://oss-resource668.yzdli.com/website/image/default/com_user_b.png";
export const DEFAULTS_COMPANY_ICON = "https://oss-resource668.yzdli.com/website/image/icon/iconcompany-fill.png";
export const INVITE_POSTER_BG = "https://oss-resource668.yzdli.com/website/image/default/invitePosterBg.jpg";
export const INVITE_POSTER_BG_2022 = "https://resource668.oss-cn-shenzhen.aliyuncs.com/website/image/default/jfdfjlskdfjlaskdfjlksadfjoksdf454352.jpg";
export const CHOOSE_EDIT_LANG_BTN = "https://oss-resource668.yzdli.com/website/image/default/chooseEditLangBtn.jpg";
export const MODAL_TITLE_BG = "https://oss-resource668.yzdli.com/website/image/default/pic_wenxts@2x.png";
export const SUPPLY_CHAIN_CHNAP = "https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_chnap.png";
export const SUPPLY_CHAIN_LANG = "https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_lang.png";
export const SUPPLY_CHAIN_QIYE = "https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_qiye.png";
export const SUPPLY_CHAIN_VR = "https://oss-resource668.yzdli.com/website/image/icon/icon_supplyChain_vr.png";
export const IMAGE_GRAY_NOTHING = "https://oss-resource668.yzdli.com/website/image/result/pic_nothing.png";
export const IMAGE_GRAY_CONTENT = "https://oss-resource668.yzdli.com/website/image/result/pic_content.png";
export const IMAGE_GRAY_PAY = "https://oss-resource668.yzdli.com/website/image/result/result_pic_pay.png";
export const IMAGE_GRAY_VIP = "https://oss-resource668.yzdli.com/website/image/result/result_pic_vip.png";
export const iconCaigje = "https://oss-resource668.yzdli.com/website/image/home/home_icon_caigje@2x.webp";
export const iconYaoykh = "https://oss-resource668.yzdli.com/website/image/home/home_icon_yaoykh@2x.webp";
export const iconYouhq = "https://oss-resource668.yzdli.com/website/image/home/home_icon_youhq@2x.webp";
export const iconGuanzrc = "https://oss-resource668.yzdli.com/website/image/home/home_icon_guanzrc@2x.webp";
export const iconToubj = "https://oss-resource668.yzdli.com/website/image/home/home_icon_toubj@2x.webp";
export const homeIconYunzxt = "https://oss-resource668.yzdli.com/website/image/home/home_icon_yunzxt@2x.webp";
export const iconYunsj = "https://oss-resource668.yzdli.com/website/image/home/me_icon_yunsj@2x.webp";
export const iconYunhz = "https://oss-resource668.yzdli.com/website/image/home/me_icon_yunhz@2x.webp";
export const iconYunzb = "https://oss-resource668.yzdli.com/website/image/home/home_icon_yunzb@2x.webp";
export const iconYuncg = "https://oss-resource668.yzdli.com/website/image/home/home_icon_yuncg@2x.webp";
export const iconYunzs = "https://oss-resource668.yzdli.com/website/image/home/home_icon_yunzs@2x.png";
export const IMAGE_RESULT_FORM = "https://oss-resource668.yzdli.com/website/image/success/form.png";
export const ICON_MILITARY_EMBLEM = "https://oss-resource668.yzdli.com/website/image/icon/icon_military_emblem.png";
export const ICON_HONGBAO = "https://oss-resource668.yzdli.com/website/image/default/pic_hongb.png";
export const IMAGE_HUODONG_BG = "https://oss-resource668.yzdli.com/website/image/default/yaoq_pic_huodong.png";
export const ICON_YAOXJL = "https://oss-resource668.yzdli.com/website/image/default/pic_yaoxjl.jpg";
export const ICON_QIANBAO_ICON = "https://oss-resource668.yzdli.com/website/image/icon/qianb_pic_qianbao.png";
export const ICON_HOT_GIF = "https://oss-resource668.yzdli.com/website/image/default/hot.gif";
export const ICON_GOLD_COMPANY = "https://oss-resource668.yzdli.com/website/image/icon/icon_gold_company.png";
export const ICON_GRAY_COMPANY = "https://oss-resource668.yzdli.com/website/image/icon/icon_gray_company.png";
export const ICON_GOLD_PEOPLE = "https://oss-resource668.yzdli.com/website/image/icon/icon_gold_people.png";
export const ICON_GRAY_PEOPLE = "https://oss-resource668.yzdli.com/website/image/icon/icon_gray_people.png";
export const ICON_GRIANGLE_GREEN = "https://oss-resource668.yzdli.com/website/image/icon/icon_triangle_green.png";
export const ICON_GRIANGLE_RED = "https://oss-resource668.yzdli.com/website/image/icon/icon_triangle_red.png";
export const IMAGE_ADDRESS = "https://oss-resource668.yzdli.com/website/image/icon/icon_address.png";
export const IMAGE_LOADING = "https://oss-resource668.yzdli.com/website/image/default/spinner.gif";
export const MINI_CHART1 = "https://oss-resource668.yzdli.com/website/image/default/miniChat1.png";
export const MINI_CHART2 = "https://oss-resource668.yzdli.com/website/image/default/miniChat2.png";
export const MINI_CHART3 = "https://oss-resource668.yzdli.com/website/image/default/miniChat3.png";
export const MINI_CHART4 = "https://oss-resource668.yzdli.com/website/image/default/miniChat4.png";
export const IMAGE_ICON_NODATA = "https://oss-resource668.yzdli.com/website/image/icon/result_pic_nodata.png";
export const IMAGE_ICON_NOTIFICATIONS = "https://oss-resource668.yzdli.com/website/image/icon/notifications-center.png";
export const IMAGE_ICON_BELL = "https://oss-resource668.yzdli.com/website/image/icon/icon_bell_yellow.png";
export const IMAGE_ICON_MAIL = "https://oss-resource668.yzdli.com/website/image/icon/icon_mail_blue.png";
export const ICON_REGISTER_CANZHAN = "https://oss-resource668.yzdli.com/website/image/icon/register_canzhan.png";
export const ICON_REGISTER_ZHUBAN = "https://oss-resource668.yzdli.com/website/image/icon/register_zhuban.png";
export const ICON_REGISTER_FUWUSHANG = "https://oss-resource668.yzdli.com/website/image/icon/register_fuwushang.png";
export const ICON_WENXIN = "https://oss-resource668.yzdli.com/website/image/icon/icon_weixin.png";
export const ICON_COLLECT = "https://oss-resource668.yzdli.com/website/image/icon/shoucang.png";
export const ICON_NOW_TIME_DATA = "https://oss-resource668.yzdli.com/website/image/icon/ssshuju.png";
export const ICON_EN_NOW_TIME_DATA = "https://oss-resource668.yzdli.com/website/image/icon/ssshuju_en.png";
export const ICON_NOW_TIME_DATA_227 = "https://oss-resource668.yzdli.com/website/image/icon/ssshuju_227.png?v=3";
export const ICON_EN_NOW_TIME_DATA_227 = "https://oss-resource668.yzdli.com/website/image/icon/ssshuju_en.png";
export const ICON_3D_COMPANY = "https://oss-resource668.yzdli.com/website/image/icon/3Dcompany.png";
export const ICON_ZHU_YE = "https://oss-resource668.yzdli.com/website/image/icon/zhuye.png";
export const ICON_NEW = "https://oss-resource668.yzdli.com/website/image/icon/new.png";
export const ICON_ERROR_VIDEO = "https://oss-resource668.yzdli.com/website/image/icon/error_pic_video-01.png";
export const ICON_SMART_SEARCH = "https://oss-resource668.yzdli.com/website/image/icon/smart_search.png";
export const ICON_SEARCH_GRAY = "https://oss-resource668.yzdli.com/website/image/icon/icon_search_gray.png";
export const ICON_PREVIEW = "https://oss-resource668.yzdli.com/website/image/icon/preview.png";
export const ICON_IMPORT = "https://oss-resource668.yzdli.com/website/image/icon/icon_import.png";
export const ICON_CLOSE = "https://oss-resource668.yzdli.com/website/image/icon/close.png";
export const ICON_LINK = "https://oss-resource668.yzdli.com/website/image/icon/icon_link.png";
export const ICON_SHARE = "https://oss-resource668.yzdli.com/website/image/icon/icon_share.png";
export const ICON_SHARE_SHADOW = "https://oss-resource668.yzdli.com/website/image/icon/icon_share_shadow.png";
export const ICON_SHARE_GRAY = "https://oss-resource668.yzdli.com/website/image/icon/icon_share_gray.png";
export const ICON_SHARE_FFF = "https://oss-resource668.yzdli.com/website/image/icon/icon_share_fff.png";
export const ICON_LOCK_FFF = "https://oss-resource668.yzdli.com/website/image/icon/icon_lock.png";
export const ICON_CERTIFICATE = "https://oss-resource668.yzdli.com/website/image/icon/icon_certificate.png";
export const ICON_GONGSHANG = "https://oss-resource668.yzdli.com/website/image/icon/icon_gongshang.png";
export const ICON_SWITCH = "https://oss-resource668.yzdli.com/website/image/icon/icon_switch.png";
export const ICON_MSG = "https://oss-resource668.yzdli.com/website/image/icon/icon_msg.png";
export const ICON_RIGHT = "https://oss-resource668.yzdli.com/website/image/icon/icon_right.png";
export const ICON_OFFICIAL_WEBSITE = "https://oss-resource668.yzdli.com/website/image/icon/officialWebsite.png";
export const ICON_VIDEO_PLAY = "https://oss-resource668.yzdli.com/website/image/icon/video-play.png";
export const ICON_B_PLAY = "https://oss-resource668.yzdli.com/website/image/icon/b_play.png";
export const ICON_CHAT_DOT_RED = "https://oss-resource668.yzdli.com/website/image/icon/icon_chat_dot_red.png";
export const ICON_MP_PRESS = "https://oss-resource668.yzdli.com/website/image/icon/icon_mp_press.png";
export const ICON_CHAT_HANGUP = "https://oss-resource668.yzdli.com/website/image/icon/icon_chat_hangUp.png";
export const ICON_CHAT_CONNECT = "https://oss-resource668.yzdli.com/website/image/icon/icon_chat_connect.png";
export const ICON_VIP_CHOICE = "https://oss-resource668.yzdli.com/website/image/icon/icon_vip_Choice.png";
export const ICON_ENTER_SMS = "https://oss-resource668.yzdli.com/website/image/icon/icon_enter_sms.png";
export const ICON_ENTER_FULL = "https://oss-resource668.yzdli.com/website/image/icon/icon_enter_full.png";
export const ICON_YUNZH_TAG = "https://oss-resource668.yzdli.com/website/image/default/yunzhTag.png?v=3";
export const ICON_FUWS = "https://oss-resource668.yzdli.com/website/image/default/pic_fuws.png";
export const ICON_ZHUBS = "https://oss-resource668.yzdli.com/website/image/default/pic_zhubs.png";
export const ICON_MY_DATA_CHA_KAN = "https://oss-resource668.yzdli.com/website/image/icon/icon_myData_chakan.svg";
export const ICON_MY_DATA_DIAN_ZAN = "https://oss-resource668.yzdli.com/website/image/icon/icon_myData_dianzan.svg";
export const ICON_MY_DATA_SHARE = "https://oss-resource668.yzdli.com/website/image/icon/icon_myData_share.svg";
export const ICON_MY_DATA_ZHUAN_FA = "https://oss-resource668.yzdli.com/website/image/icon/icon_myData_zhuanfa.svg";
export const ICON_MY_DATA_QI_YE_HK = "https://oss-resource668.yzdli.com/website/image/icon/pic_qiyehk@2x.png";
export const ICON_MY_DATA_WEI_GEN_JIN = "https://oss-resource668.yzdli.com/website/image/icon/pic_weigenjin@2x.png";
export const ICON_MY_DATA_YI_GEN_JIN = "https://oss-resource668.yzdli.com/website/image/icon/pic_yigenjin@2x.png";
export const ICON_MY_DATA_YUAN_GFX = "https://oss-resource668.yzdli.com/website/image/icon/pic_yuangfx@2x.png";
export const ICON_QI_YE_REN_ZHENG = "https://oss-resource668.yzdli.com/website/image/icon/icon_renzheng@2x.png";
export const ICON_BIAN_GEN = "https://oss-resource668.yzdli.com/website/image/icon/icon_biangeng@2x.png";
export const OCCUPIED_CONTENT = "https://oss-resource668.yzdli.com/website/image/occupied/pic_content.png";
export const OCCUPIED_MODEL = "https://oss-resource668.yzdli.com/website/image/occupied/model.png";
export const OCCUPIED_PRODUCT = "https://oss-resource668.yzdli.com/website/image/occupied/product.png";
export const OCCUPIED_SCENES = "https://oss-resource668.yzdli.com/website/image/occupied/com_perch_view.png";
export const OCCUPIED_COMPANY = "https://oss-resource668.yzdli.com/website/image/occupied/com_perch_office.png";
export const OCCUPIED_LIVE = "https://oss-resource668.yzdli.com/website/image/occupied/com_perch_live.png";
export const EMPTY_CARD_LIST = "https://oss-resource668.yzdli.com/website/image/success/emptyCard.png";
export const LOGO = "https://oss-resource668.yzdli.com/website/image/logo/logo.png?v=2";
export const LOGO_UP_DOWN = "https://oss-resource668.yzdli.com/website/image/logo/pc_logo_lite.jpg";
export const LOGO_SMALL = "https://oss-resource668.yzdli.com/website/image/logo/logo-small.png";
export const PIC_LOGO = "https://resource668.oss-cn-shenzhen.aliyuncs.com/website/image/logo/pic_logo.png";
export const APP_DOWNLOAD = "https://oss-resource668.yzdli.com/website/QRcode/app_download.png?v=3";
export const AI_SYSTEM_IMAGE = "https://oss-resource668.yzdli.com/website/QRcode/aiSystemHome.jpg";
export const LIVE_PAGE = "https://oss-resource668.yzdli.com/website/operation/live_qrcode.jpg";
export const NAMECARD_BG = "https://oss-resource668.yzdli.com/website/image/bg/namecard_bg.jpg";
export const NAMECARD_LOGO = "https://oss-resource668.yzdli.com/website/image/bg/namecard_logo.png";
export const LOGIN_BG = "https://oss-resource668.yzdli.com/website/image/bg/loginBg.jpg";
export const VIP_LEVEL1 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level1.png";
export const VIP_LEVEL2 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level2.png";
export const VIP_LEVEL3 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level3.png";
export const VIP_LEVEL4 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level4.png";
export const VIP_LEVEL5 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/level5.png";
export const ICON_HOT = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/icon_hot.png";
export const VIP_INTRODUCTION_0 = "https://oss-resource668.yzdli.com/website/activity/recommend/img1.png";
export const VIP_INTRODUCTION_1 = "https://oss-resource668.yzdli.com/website/activity/recommend/img_2.png";
export const VIP_INTRODUCTION_2 = "https://oss-resource668.yzdli.com/website/activity/recommend/Frame 167.png";
export const VIP_INTRODUCTION_3 = "https://oss-resource668.yzdli.com/website/activity/recommend/img1.png";
export const VIP_INTRODUCTION_4 = "https://oss-resource668.yzdli.com/website/activity/recommend/Frame 170.png";
export const VIP_INTRODUCTION_5 = "https://oss-resource668.yzdli.com/website/activity/recommend/Frame 155.png";
export const VIP_LEVEL_COMPANY_LOGO = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/companyLogo/";
export const VIP_LEVEL_BG = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/huiy_pic_bj.jpeg";
export const VIP_LEVEL_0 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_profile.png";
export const VIP_LEVEL_1 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png";
export const VIP_LEVEL_2 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png";
export const VIP_LEVEL_3 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png";
export const VIP_LEVEL_4 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png";
export const VIP_LEVEL_5 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png";
export const VIP_LEVEL_6 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_shangwuban.png";
export const VIP_LEVEL_7 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_qijianban.png";
export const VIP_LEVEL_8 = "https://oss-resource668.yzdli.com/website/image/icon/vipLevel/badge_metauniverse.png";
export const ICON_YES = "https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_yes.png";
export const ICON_YES2 = "https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_yes2.jpg";
export const ICON_YELLOW_CONTRACTORS = "https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_contractors.png";
export const ICON_YELLOW_SPONSOR = "https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_sponsor.png";
export const ICON_YELLOW_DESIGNER = "https://oss-resource668.yzdli.com/website/image/icon/icon_yellow_designer.png";
export const DEFAULTPAGE_ZZH = "https://oss-resource668.yzdli.com/defaultPage/pic_wmingp.png";
export const DEFAULTPAGE_SJNR = "https://oss-resource668.yzdli.com/defaultPage/pic_wusj.png";
export const DEFAULTPAGE_QT = "https://oss-resource668.yzdli.com/defaultPage/pic_wqiat.png";
export const DEFAULTPAGE_WLYC = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wanglyc.png";
export const DEFAULTPAGE_MP = "https://oss-resource668.yzdli.com/defaultPage/pic_wump.png";
export const DEFAULTPAGE_YHQ = "https://oss-resource668.yzdli.com/defaultPage/pic_wuyhq.png";
export const DEFAULTPAGE_JL = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wjil.png";
export const DEFAULTPAGE_SC = "https://oss-resource668.yzdli.com/defaultPage/pic_wusc.png";
export const DEFAULTPAGE_GYS = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_gys.png";
export const DEFAULTPAGE_WMINGP = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wmingp.png";
export const DEFAULTPAGE_WQIAT = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wqiat.png";
export const DEFAULTPAGE_WUMP = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wump.png";
export const DEFAULTPAGE_WUSC = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wusc.png";
export const DEFAULTPAGE_WUSJ = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wusj.png";
export const DEFAULTPAGE_WUYHQ = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_wuyhq.png";
export const DEFAULTPAGE_XIAJIA = "https://oss-resource668.yzdli.com/website/image/supplyV2/empty/pic_xiajia.png";
export const TEMPLATE = "https://oss-resource668.yzdli.com/website/image/email/pic_yjmb.png";
export const CUSTOMER_DATABASE = "https://oss-resource668.yzdli.com/website/image/email/pic_khk.png";
export const CREATE_TASK = "https://oss-resource668.yzdli.com/website/image/email/pic_cjrw.png";
export const VIEW_STATISTICS = "https://oss-resource668.yzdli.com/website/image/email/pic_tj.png";

export const result = {
  IMAGE_GRAY_NOTHING,
  IMAGE_GRAY_CONTENT,
  IMAGE_GRAY_PAY,
  IMAGE_GRAY_VIP,
};

export const home = {
  iconCaigje,
  iconYaoykh,
  iconYouhq,
  iconGuanzrc,
  iconToubj,
  homeIconYunzxt,
  iconYunsj,
  iconYunhz,
  iconYunzb,
  iconYuncg,
  iconYunzs,
};

export const vipLevel = {
  VIP_LEVEL1,
  VIP_LEVEL2,
  VIP_LEVEL3,
  VIP_LEVEL4,
  VIP_LEVEL5,
  ICON_HOT,
  VIP_INTRODUCTION_0,
  VIP_INTRODUCTION_1,
  VIP_INTRODUCTION_2,
  VIP_INTRODUCTION_3,
  VIP_INTRODUCTION_4,
  VIP_INTRODUCTION_5,
  VIP_LEVEL_COMPANY_LOGO,
  VIP_LEVEL_BG,
  VIP_LEVEL_0,
  VIP_LEVEL_1,
  VIP_LEVEL_2,
  VIP_LEVEL_3,
  VIP_LEVEL_4,
  VIP_LEVEL_5,
  VIP_LEVEL_6,
  VIP_LEVEL_7,
  VIP_LEVEL_8,
  ICON_YES,
  ICON_YES2,
  ICON_YELLOW_CONTRACTORS,
  ICON_YELLOW_SPONSOR,
  ICON_YELLOW_DESIGNER,
};

export const defaults = {
  DEFAULTS_AVATAR,
  DEFAULTS_AVATAR_BIG,
  DEFAULTS_COMPANY_ICON,
  INVITE_POSTER_BG,
  INVITE_POSTER_BG_2022,
  CHOOSE_EDIT_LANG_BTN,
  MODAL_TITLE_BG,
  SUPPLY_CHAIN_CHNAP,
  SUPPLY_CHAIN_LANG,
  SUPPLY_CHAIN_QIYE,
  SUPPLY_CHAIN_VR,
};

export const success = {
  IMAGE_RESULT_FORM,
};

export const icon = {
  ICON_MILITARY_EMBLEM,
  ICON_HONGBAO,
  IMAGE_HUODONG_BG,
  ICON_YAOXJL,
  ICON_QIANBAO_ICON,
  ICON_HOT_GIF,
  ICON_GOLD_COMPANY,
  ICON_GRAY_COMPANY,
  ICON_GOLD_PEOPLE,
  ICON_GRAY_PEOPLE,
  ICON_GRIANGLE_GREEN,
  ICON_GRIANGLE_RED,
  IMAGE_ADDRESS,
  IMAGE_LOADING,
  MINI_CHART1,
  MINI_CHART2,
  MINI_CHART3,
  MINI_CHART4,
  IMAGE_ICON_NODATA,
  IMAGE_ICON_NOTIFICATIONS,
  IMAGE_ICON_BELL,
  IMAGE_ICON_MAIL,
  ICON_REGISTER_CANZHAN,
  ICON_REGISTER_ZHUBAN,
  ICON_REGISTER_FUWUSHANG,
  ICON_WENXIN,
  ICON_COLLECT,
  ICON_NOW_TIME_DATA,
  ICON_EN_NOW_TIME_DATA,
  ICON_NOW_TIME_DATA_227,
  ICON_EN_NOW_TIME_DATA_227,
  ICON_3D_COMPANY,
  ICON_ZHU_YE,
  ICON_NEW,
  ICON_ERROR_VIDEO,
  ICON_SMART_SEARCH,
  ICON_SEARCH_GRAY,
  ICON_PREVIEW,
  ICON_IMPORT,
  ICON_CLOSE,
  ICON_LINK,
  ICON_SHARE,
  ICON_SHARE_SHADOW,
  ICON_SHARE_GRAY,
  ICON_SHARE_FFF,
  ICON_LOCK_FFF,
  ICON_CERTIFICATE,
  ICON_GONGSHANG,
  ICON_SWITCH,
  ICON_MSG,
  ICON_RIGHT,
  ICON_OFFICIAL_WEBSITE,
  ICON_VIDEO_PLAY,
  ICON_B_PLAY,
  ICON_CHAT_DOT_RED,
  ICON_MP_PRESS,
  ICON_CHAT_HANGUP,
  ICON_CHAT_CONNECT,
  ICON_VIP_CHOICE,
  ICON_ENTER_SMS,
  ICON_ENTER_FULL,
  ICON_YUNZH_TAG,
  ICON_FUWS,
  ICON_ZHUBS,
  ICON_MY_DATA_CHA_KAN,
  ICON_MY_DATA_DIAN_ZAN,
  ICON_MY_DATA_SHARE,
  ICON_MY_DATA_ZHUAN_FA,
  ICON_MY_DATA_QI_YE_HK,
  ICON_MY_DATA_WEI_GEN_JIN,
  ICON_MY_DATA_YI_GEN_JIN,
  ICON_MY_DATA_YUAN_GFX,
  ICON_QI_YE_REN_ZHENG,
  ICON_BIAN_GEN,
};

export const occupied = {
  OCCUPIED_CONTENT,
  OCCUPIED_MODEL,
  OCCUPIED_PRODUCT,
  OCCUPIED_SCENES,
  OCCUPIED_COMPANY,
  OCCUPIED_LIVE,
  EMPTY_CARD_LIST,
};

export const logo = {
  LOGO,
  LOGO_UP_DOWN,
  LOGO_SMALL,
  PIC_LOGO,
};

export const qrcode = {
  APP_DOWNLOAD,
  AI_SYSTEM_IMAGE,
};

export const operation = {
  LIVE_PAGE,
};

export const bg = {
  NAMECARD_BG,
  NAMECARD_LOGO,
  LOGIN_BG,
};

export const defaultPage = {
  DEFAULTPAGE_ZZH,
  DEFAULTPAGE_SJNR,
  DEFAULTPAGE_QT,
  DEFAULTPAGE_WLYC,
  DEFAULTPAGE_MP,
  DEFAULTPAGE_YHQ,
  DEFAULTPAGE_JL,
  DEFAULTPAGE_SC,
  DEFAULTPAGE_GYS,
  DEFAULTPAGE_WMINGP,
  DEFAULTPAGE_WQIAT,
  DEFAULTPAGE_WUMP,
  DEFAULTPAGE_WUSC,
  DEFAULTPAGE_WUSJ,
  DEFAULTPAGE_WUYHQ,
  DEFAULTPAGE_XIAJIA,
};

export const emailBg = {
  TEMPLATE,
  CUSTOMER_DATABASE,
  CREATE_TASK,
  VIEW_STATISTICS,
};

export default {
  DEFAULTS_AVATAR,
  DEFAULTS_AVATAR_BIG,
  DEFAULTS_COMPANY_ICON,
  INVITE_POSTER_BG,
  INVITE_POSTER_BG_2022,
  CHOOSE_EDIT_LANG_BTN,
  MODAL_TITLE_BG,
  SUPPLY_CHAIN_CHNAP,
  SUPPLY_CHAIN_LANG,
  SUPPLY_CHAIN_QIYE,
  SUPPLY_CHAIN_VR,
  IMAGE_GRAY_NOTHING,
  IMAGE_GRAY_CONTENT,
  IMAGE_GRAY_PAY,
  IMAGE_GRAY_VIP,
  iconCaigje,
  iconYaoykh,
  iconYouhq,
  iconGuanzrc,
  iconToubj,
  homeIconYunzxt,
  iconYunsj,
  iconYunhz,
  iconYunzb,
  iconYuncg,
  iconYunzs,
  IMAGE_RESULT_FORM,
  ICON_MILITARY_EMBLEM,
  ICON_HONGBAO,
  IMAGE_HUODONG_BG,
  ICON_YAOXJL,
  ICON_QIANBAO_ICON,
  ICON_HOT_GIF,
  ICON_GOLD_COMPANY,
  ICON_GRAY_COMPANY,
  ICON_GOLD_PEOPLE,
  ICON_GRAY_PEOPLE,
  ICON_GRIANGLE_GREEN,
  ICON_GRIANGLE_RED,
  IMAGE_ADDRESS,
  IMAGE_LOADING,
  MINI_CHART1,
  MINI_CHART2,
  MINI_CHART3,
  MINI_CHART4,
  IMAGE_ICON_NODATA,
  IMAGE_ICON_NOTIFICATIONS,
  IMAGE_ICON_BELL,
  IMAGE_ICON_MAIL,
  ICON_REGISTER_CANZHAN,
  ICON_REGISTER_ZHUBAN,
  ICON_REGISTER_FUWUSHANG,
  ICON_WENXIN,
  ICON_COLLECT,
  ICON_NOW_TIME_DATA,
  ICON_EN_NOW_TIME_DATA,
  ICON_NOW_TIME_DATA_227,
  ICON_EN_NOW_TIME_DATA_227,
  ICON_3D_COMPANY,
  ICON_ZHU_YE,
  ICON_NEW,
  ICON_ERROR_VIDEO,
  ICON_SMART_SEARCH,
  ICON_SEARCH_GRAY,
  ICON_PREVIEW,
  ICON_IMPORT,
  ICON_CLOSE,
  ICON_LINK,
  ICON_SHARE,
  ICON_SHARE_SHADOW,
  ICON_SHARE_GRAY,
  ICON_SHARE_FFF,
  ICON_LOCK_FFF,
  ICON_CERTIFICATE,
  ICON_GONGSHANG,
  ICON_SWITCH,
  ICON_MSG,
  ICON_RIGHT,
  ICON_OFFICIAL_WEBSITE,
  ICON_VIDEO_PLAY,
  ICON_B_PLAY,
  ICON_CHAT_DOT_RED,
  ICON_MP_PRESS,
  ICON_CHAT_HANGUP,
  ICON_CHAT_CONNECT,
  ICON_VIP_CHOICE,
  ICON_ENTER_SMS,
  ICON_ENTER_FULL,
  ICON_YUNZH_TAG,
  ICON_FUWS,
  ICON_ZHUBS,
  ICON_MY_DATA_CHA_KAN,
  ICON_MY_DATA_DIAN_ZAN,
  ICON_MY_DATA_SHARE,
  ICON_MY_DATA_ZHUAN_FA,
  ICON_MY_DATA_QI_YE_HK,
  ICON_MY_DATA_WEI_GEN_JIN,
  ICON_MY_DATA_YI_GEN_JIN,
  ICON_MY_DATA_YUAN_GFX,
  ICON_QI_YE_REN_ZHENG,
  ICON_BIAN_GEN,
  OCCUPIED_CONTENT,
  OCCUPIED_MODEL,
  OCCUPIED_PRODUCT,
  OCCUPIED_SCENES,
  OCCUPIED_COMPANY,
  OCCUPIED_LIVE,
  EMPTY_CARD_LIST,
  LOGO,
  LOGO_UP_DOWN,
  LOGO_SMALL,
  PIC_LOGO,
  APP_DOWNLOAD,
  AI_SYSTEM_IMAGE,
  LIVE_PAGE,
  NAMECARD_BG,
  NAMECARD_LOGO,
  LOGIN_BG,
  VIP_LEVEL1,
  VIP_LEVEL2,
  VIP_LEVEL3,
  VIP_LEVEL4,
  VIP_LEVEL5,
  ICON_HOT,
  VIP_INTRODUCTION_0,
  VIP_INTRODUCTION_1,
  VIP_INTRODUCTION_2,
  VIP_INTRODUCTION_3,
  VIP_INTRODUCTION_4,
  VIP_INTRODUCTION_5,
  VIP_LEVEL_COMPANY_LOGO,
  VIP_LEVEL_BG,
  VIP_LEVEL_0,
  VIP_LEVEL_1,
  VIP_LEVEL_2,
  VIP_LEVEL_3,
  VIP_LEVEL_4,
  VIP_LEVEL_5,
  VIP_LEVEL_6,
  VIP_LEVEL_7,
  VIP_LEVEL_8,
  ICON_YES,
  ICON_YES2,
  ICON_YELLOW_CONTRACTORS,
  ICON_YELLOW_SPONSOR,
  ICON_YELLOW_DESIGNER,
  DEFAULTPAGE_ZZH,
  DEFAULTPAGE_SJNR,
  DEFAULTPAGE_QT,
  DEFAULTPAGE_WLYC,
  DEFAULTPAGE_MP,
  DEFAULTPAGE_YHQ,
  DEFAULTPAGE_JL,
  DEFAULTPAGE_SC,
  DEFAULTPAGE_GYS,
  DEFAULTPAGE_WMINGP,
  DEFAULTPAGE_WQIAT,
  DEFAULTPAGE_WUMP,
  DEFAULTPAGE_WUSC,
  DEFAULTPAGE_WUSJ,
  DEFAULTPAGE_WUYHQ,
  DEFAULTPAGE_XIAJIA,
  TEMPLATE,
  CUSTOMER_DATABASE,
  CREATE_TASK,
  VIEW_STATISTICS,
};
